import { Reducer } from 'redux';
import { Action } from 'Store/types';

export enum ActionTypes {
  SET_OWNER_EDIT = '@ownerEdit/SET',
}
export type OwnerEdit = any;

export type OwnerEditReducer = Reducer<OwnerEdit, Action<ActionTypes>>;
